interface Props {
  t: (key: string) => string;
}

const EMAIL = 'mailto:gustavo.sanchez@grupoprisma.tech';

export function Footer({ t }: Props) {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div className="container foot">
        <div className="left">
          <svg width="20" height="20" viewBox="0 0 32 32" aria-hidden="true">
            <circle cx="16" cy="16" r="15" fill="currentColor" opacity=".18" />
            <path
              d="M10 8 L10 24 M10 16 L18 16 C20 16 22 14 22 12 M22 12 L22 24"
              stroke="currentColor"
              strokeWidth="2.4"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>
            hook. — <a href={EMAIL}>{t('footer.tagline')}</a>
          </span>
        </div>
        <div className="mono">
          {t('footer.copy')} {year}
        </div>
      </div>
    </footer>
  );
}
